export const aos = () => {
    const figureKVs = document.querySelectorAll(".hero__figure, .kvSec__figure");
    // Start fading in the KV figures immediately
    figureKVs.forEach(figureKV => {
        if (figureKV) {
            figureKV.style.animationDelay = "0s";
        }
    });

    // Delay the fade-in for hero/kv text and titles by 2 seconds
    const delayedTextElements = document.querySelectorAll(".hero__title, .hero__text, .kvSec__title, .kvSec__text");
    delayedTextElements.forEach(el => {
        if (el) {
            setTimeout(() => {
                el.style.animation = "fadeIn 1s ease-in-out forwards";
            }, 2000);
        }
    });

    // Scroll Sentinel for scrolled class on .hero__float
    const heroFloat = document.querySelector(".hero__float");
    if (heroFloat) {
        // Animate entrance after 800ms delay
        setTimeout(() => {
            heroFloat.classList.add("is-visible");
        }, 800);

        const sentinel = document.createElement("div");
        sentinel.style.position = "absolute";
        sentinel.style.top = "0";
        sentinel.style.left = "0";
        sentinel.style.height = "1px";
        sentinel.style.width = "100%";
        sentinel.style.pointerEvents = "none";

        const heroInner = document.querySelector(".hero__inner") || document.body;
        heroInner.appendChild(sentinel);

        const scrollObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    heroFloat.classList.add("scrolled");
                } else {
                    heroFloat.classList.remove("scrolled");
                }
            });
        }, {
            rootMargin: "50px 0px 0px 0px"
        });
        scrollObserver.observe(sentinel);
    }

    // Select all figures except KV figures
    const figures = document.querySelectorAll("figure:not(.hero__figure):not(.kvSec__figure)");

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("fadeInUp", "is-visible");
                observer.unobserve(entry.target); // Stop observing after animation runs once
            }
        });
    }, { threshold: 0.2 });

    figures.forEach(figure => observer.observe(figure));

}